import React from "react";
import styled from "styled-components";

interface TitleWithLineProps {
  title: string;
}

export default function TitleWithLine({ title }: TitleWithLineProps) {
  return (
    <TitleWithLineContainer>
      <Title>{title}</Title>
      <Underline />
    </TitleWithLineContainer>
  );
}

const TitleWithLineContainer = styled.div`
  display: inline-block;
  position: relative;
`;

const Title = styled.span`
  position: relative;
  z-index: 2;
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
  text-align: left;
  color: #2f2f38;
`;

const Underline = styled.div`
  width: 100%;
  height: 6px;
  background-color: #93fcfc;
  position: absolute;
  bottom: 0;
  z-index: 1;
`;
